"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSalesContactsStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useSalesContactsStore = (0, pinia_1.defineStore)("salesContacts", {
    state: () => ({
        salesContacts: []
    }),
    actions: {
        async getCustomerSalesContacts(router, siteId, isExportContact) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "api_sales_contacts", query: { siteId, isExportContact } }).href);
                const salesContacts = [];
                if (response['hydra:member'] && Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] === 'SalesContact') {
                            salesContacts.push(element);
                        }
                    });
                }
                this.salesContacts = salesContacts;
                return salesContacts;
            }
            catch (error) {
                console.error("Failed to fetch salesContacts:", error);
                throw error;
            }
        }
    }
});
